<script lang="ts">
  /**
   * AppInput's multi-line sibling. A textarea's height is rows, not a control-height token, so this
   * borrows only the border/radius/focus half of AppInput's tokens, not its SIZES map.
   */
  let {
    value = $bindable(""),
    rows = 3,
    placeholder,
    disabled = false,
    ...rest
  }: {
    value?: string;
    rows?: number;
    placeholder?: string;
    disabled?: boolean;
    [key: string]: unknown;
  } = $props();
</script>

<textarea
  bind:value
  {rows}
  {placeholder}
  {disabled}
  {...rest}
  class="w-full rounded-control border border-line bg-white text-ink placeholder:text-ink-muted
         px-3.5 py-2.5 text-sm resize-none
         transition-colors duration-200 ease-out
         hover:border-ink-muted focus:border-accent focus:outline-none
         disabled:opacity-50 disabled:cursor-not-allowed"
></textarea>
